import { configureStore } from "@reduxjs/toolkit";
import getCountriesSlice from "../features/getCountriesSlice";
import userProfileSlice from '../features/getUserProfile';

export default configureStore({
  reducer: {
    getCountries: getCountriesSlice,
    userProfile:userProfileSlice,
  },
});
